const initialState = {
  collection: [],
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "TAKE_ACTION_FULFILLED": {
      const collection = state.collection.filter(each => each.type !== 'Action');
      return {
        ...state,
        collection: [
          ...collection,
        ]
      };
    }

    case "NEW_NOTIFICATIONS": {
      const collection = state.collection.filter(each => each.type !== 'Action');
      return {
        ...state,
        collection: [
          ...collection,
          ...action.data.filter(each =>
            state.collection.findIndex(i => i.id === each.id) < 0
          )
        ]
      };
    }

    case "DISMISS_NOTIFICATION":
      return {
        ...state,
        collection: state.collection.filter(each => {
          if (each.id === action.data.id) {
            return each.type !== action.data.type;
          }
          return true;
        })
      };

    case "MUTE_NOTIFICATION":
      return {
        ...state,
        collection: state.collection.map(each => {
          if (each.id === action.data.id && each.type === action.data.type) {
            each.mute = 1;
          }
          return each;
        })
      };

    case "RESET":
    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
